/*
 * @Author: songxiaoqiang
 * @Date: 2020-09-21 17:49:46
 * @Last Modified by: songxiaoqiang
 * @Last Modified time: Do not edit
 * @Description:
 */
import React from "react";
import PropTypes from "prop-types";
import axios from "axios/dist/axios.min.js";
import utils from "../../utils/utils";
import parseParams from "../../utils/parseParams";
import parseToken from "../../utils/parseToken";
import "./style.less";

class PipelineFreeSubsidy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      tabIndex: 0
    };
  }

  componentDidMount() {
    this.getProductData();
  }

  getProductData() {
    const tabList = this.props.config.tabList;
    const idList = []
    tabList.forEach(tabItems => {
      tabItems.forEach(item => {
        idList.push(isNaN(Number(item.id)) ? 0 : Number(item.id))
      })
    })

    let reqUrl = "";
    if (this.props.config.baseConfig.type === "商品id") {
      reqUrl =
        "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur";
    } else {
      reqUrl =
        "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur";
    }

    axios({
      url: reqUrl,
      method: "post",
      withCredentials: true,
      data: {
        ids: idList,
        sort_tag: 0,
        from: this.props.specialApiFrom
      },
    }).then((res) => {
      if (res.data.status === 0) {
        const dataList = res.data.data.List;
        tabList.forEach(tabItems => {
          tabItems.forEach(item => {
            const itemData = dataList.find((dataItem) => dataItem.id === item.id);
            if (itemData) {
              Object.assign(item, itemData);
            }
          })
        })
        this.setState({
          list: tabList,
        });
      }
    });
  }

  productClick = (item, index) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.link,
        props: this.props,
        index
      })
      return
    }
    const baseConfig = this.props.config.baseConfig;
    const options = {
      title: 1,
      name: item.title,
      sort: index
    };
    if (baseConfig.productType === "商品id") {
      options.goods_id = item.id;
    } else {
      options.style_id = item.id;
    }
    utils.jumpToUrl(this.props.routeParams,item.url,item.url,options,-1,this.props);
  }

  onTabClick = (tabIndex) => {
    this.setState({
      tabIndex
    })
  }

  render() {
    const { baseConfig, tabList = [] } = this.props.config;
    console.log('baseConfig', this.props)

    const { tabIndex, list = [] } = this.state
    const itemList = list[tabIndex] || []

    const tabs = [1, 2]
    return (
      <div 
        className="pipeline-free-subsidy" 
        style={{ backgroundColor: baseConfig.comBgColor }}
        {...this.props['customAttributes']}
      >
        <div className="title-img">
          <img src={utils.formatImgUrl(baseConfig.titleImg, this.props.webpSupport)} />
        </div>
        <div className="tab-list">
          {
            tabs.map((tab, index) => {
              return (
                <img className="bg" src={utils.formatImgUrl(index == 0 ? baseConfig.tab1Img : baseConfig.tab2Img, this.props.webpSupport)} className={tabIndex == index ? 'bg' : 'bg-hidden'}/>
              )
            })
          }
          <div className="content">
            <div className="tab-btns">
              {
                tabs.map((tab, index) => {
                  return (
                    <div className="btn-tab" onClick={() => this.onTabClick(index)}></div>
                  )
                })
              }
            </div>
            <div className="list">
              {
                itemList.map((item, index) => {
                  // 计算折扣差价
                  let discount = Number(item.original_price) - Number(item.price);
                  discount = parseInt(discount);
                  if (discount < 0 || isNaN(discount)) {
                    discount = 0;
                  }
                  return (
                    <div
                      className="item"
                      key={index}
                      onClick={this.productClick.bind(this, item, index)}
                    >
                      <img className="product-img" src={utils.formatImgUrl(item.image, this.props.webpSupport)} />
                      {/* {Boolean(discount) && (
                        <div 
                          className="price-tip"
                          style={{backgroundColor: baseConfig.discountBg, color: baseConfig.discountTextColor}}
                        >直降{discount}元</div>
                      )} */}
                      {item.desc && (
                        <div 
                          className="price-tip"
                          style={{backgroundColor: baseConfig.discountBg, color: baseConfig.discountTextColor}}
                        >{item.desc}</div>
                      )}
                      <div className="product-info">
                        <div className="name">{item.name || item.title}</div>
                        <div className="price" style={{color: baseConfig.priceColor, fontStyle: baseConfig.priceFontStyle}}>
                          <span className="rmb-icon">￥</span>
                          {item.price}
                          {item.original_price > 0 && <span className="origin-price" style={{fontStyle: baseConfig.priceFontStyle}}>￥{item.original_price}</span>}
                        </div>
                      </div>
                    </div>
                  );
                })
              }
            </div>
          </div>          
        </div>
      </div>
    );
  }
}

PipelineFreeSubsidy.propTypes = {
  config: PropTypes.object.isRequired,
};

export { PipelineFreeSubsidy };
export default PipelineFreeSubsidy;



// WEBPACK FOOTER //
// ./components/pipeline-free-subsidy/index.js